var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vs-icon", {
        attrs: { icon: "history", size: "small" },
        on: { click: _vm.checkHistory }
      }),
      _vm.showModal
        ? _c(
            "b-modal",
            {
              attrs: {
                title: "Versiones anteriores",
                size: "lg",
                centered: "",
                "no-close-on-backdrop": "",
                "hide-footer": ""
              },
              model: {
                value: _vm.showModal,
                callback: function($$v) {
                  _vm.showModal = $$v
                },
                expression: "showModal"
              }
            },
            [
              _c(
                "div",
                { staticClass: "w-100 text-center" },
                [
                  _vm.loading
                    ? _c("b-spinner", { attrs: { variant: "primary" } })
                    : _vm._e()
                ],
                1
              ),
              _vm.previousVersions.length === 0 && !_vm.loading
                ? _c("h5", { staticClass: "text-center" }, [
                    _vm._v(" No hay versiones anteriores ")
                  ])
                : _vm._e(),
              !_vm.loading && _vm.previousVersions.length > 0
                ? _c("table", { staticClass: "w-100 text-center" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v(" Archivo ")]),
                        _c("th", [_vm._v(" Fecha ")]),
                        _c("th", [_vm._v(" Versión externa ")]),
                        _c("th", [_vm._v(" Tamaño ")]),
                        _c("th", [_vm._v(" Descargar ")])
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.previousVersions, function(version) {
                        return _c("tr", { key: version.versionId }, [
                          _c("td", [
                            _c(
                              "span",
                              { attrs: { title: "" + version.nombre } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("truncate")(version.nombre, 30)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateCompleteFormat")(
                                    version.fechaModificado
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(version.versionExterna) + " ")
                          ]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("formatSize")(version.peso)) +
                                " "
                            )
                          ]),
                          _c(
                            "td",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("vs-icon", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Descargar versión anterior",
                                    expression: "'Descargar versión anterior'"
                                  }
                                ],
                                staticClass: "cursor-pointer",
                                attrs: { icon: "file_download", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(version.urlDescarga)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }